import { useOnline } from "@/hooks/useOnline";
import { useSync } from "@/hooks/useSync";
import { strings } from "@/lib/strings";

/**
 * The offline and storage banners (docs/08 §8.13, docs/09 §9.9).
 *
 * Nothing is evicted or refused without the volunteer being told why.
 */
export function OfflineBanner() {
  const online = useOnline();
  const { pending, storageFull, storageNearFull } = useSync();

  if (storageFull) {
    return (
      <Banner tone="blocking">{strings.sync.storageFull}</Banner>
    );
  }

  if (storageNearFull) {
    return <Banner tone="warning">{strings.sync.storageWarning}</Banner>;
  }

  if (!online) {
    return (
      <Banner tone="warning">
        {strings.sync.offline(pending)}. Your work is saved on this device and
        will upload when you reconnect.
      </Banner>
    );
  }

  return null;
}

function Banner({
  tone,
  children,
}: {
  tone: "warning" | "blocking";
  children: React.ReactNode;
}) {
  return (
    <div
      role="status"
      className={
        tone === "blocking"
          ? "bg-red-50 px-4 py-2 text-sm text-red-900"
          : "bg-amber-50 px-4 py-2 text-sm text-amber-900"
      }
    >
      {children}
    </div>
  );
}
